import React from 'react';
import { Breadcrumb as BreadcrumbAnt } from 'antd-v5';
import { Link, sentenceCase, Text } from 'UI';

export const BREADCRUMB_HEIGHT = 55;

export interface BreadcrumbProps {
  items: {
    link: string;
    label: string;
  }[];
  onClickItem?: (key: number) => void;
}

export const Breadcrumb = ({ items, onClickItem }: BreadcrumbProps) => {
  const isLastItem = (i: number) => items.length === ++i;
  return (
    <BreadcrumbAnt
      separator={'>'}
      items={items.map(({ link, label }, index) => ({
        key: `breadcrumb-${label}`,
        onClick: () => onClickItem?.(index),
        title: isLastItem(index) ? (
          <Text type="base">{sentenceCase(label)}</Text>
        ) : (
          <Link to={link}>
            <Text hoverUnderLine cursor={'pointer'} type="base" color="grey55">
              {sentenceCase(label)}
            </Text>
          </Link>
        ),
      }))}
    />
  );
};
